export default __webpack_public_path__ + "static/media/1889.4ada0434.png";